import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAEcN-4OdYtfOB3UPs4Dwu7yM4riRO0bDc",
  authDomain: "create-3d-works.firebaseapp.com",
  projectId: "create-3d-works",
  storageBucket: "create-3d-works.firebasestorage.app",
  messagingSenderId: "275727281253",
  appId: "1:275727281253:web:0c501f5866ed36ea10aa8c",
  measurementId: "G-HG7FRSKCWV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
const auth = getAuth(app);

// Google Auth Provider
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export { auth, googleProvider };
export default app;
